import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import useHttpHook from "../../Hooks/HttpHook";
import { EventById, UpdateEventTiming } from "../../utils/ApiConstant";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import ModalWrapper from "../Common/Portals/ModalWrapper";
import Input from "../UiElement/FormElement/Input";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";

const EditEventModal = ({ eventId, handleClose, getEvents }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [loading, sendRequest, error] = useHttpHook();

  const [event, setEvent] = useState({});
  const { userDetails } = useSelector((state) => state.user);

  useEffect(() => {
    getEvent();
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
              window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  // useEffect(() => {
  //     if (event) {
  //         if (event.createdBy === userDetails._id) {
  //             handleClose()
  //         }
  //     }
  // }, [event && userDetails])

  const getEvent = async () => {
    try {
      const res = await sendRequest(`${EventById}${eventId}`);
      if (res.status === 1) {
        const obj = {
          startDate: res.data.eventTiming.startDate,
          endDate: res.data.eventTiming.endDate,
          startTime: res.data.eventTiming.startTime,
          endTime: res.data.eventTiming.endTime,
        };
        reset(obj);
        setEvent(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // console.log({ event })

  const onSubmit = async (data) => {
    try {
      const res = await sendRequest(`${UpdateEventTiming}/${eventId}`, {
        method: "put",
        data: data,
      });
      if (res.status === 1) {
        await getEvents();
        handleClose();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <MainComponentWrapper errorInfo={error} Loading={loading}>
      <ModalWrapper
        title="Edit Timing"
        // submitText={PromocodeLanguage.EditPromocodeForm.SubmitText}
        CloseModalHandler={handleClose}
        formId="edit-event"
      >
        {event && event.createdBy === userDetails._id ? (
          <form
            id="edit-event"
            className="row"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="input col-lg-12">
              <Input
                WrapperClass="col-md-12"
                element="date"
                // placeholder={FormLabal.eventStartDate.placeHolder}
                Register={register}
                Errors={errors}
                FieldName="startDate"
                Label="Start Date"
                ValidationArr={[{ Type: "required" }]}
              />
              {event.eventTiming?.eventDayType === "multi" && (
                <Input
                  WrapperClass="col-md-12"
                  element="date"
                  // placeholder={FormLabal.eventStartDate.placeHolder}
                  Register={register}
                  Errors={errors}
                  FieldName="endDate"
                  Label="End Date"
                  ValidationArr={[{ Type: "required" }]}
                />
              )}
              <Input
                WrapperClass="col-md-12"
                // defValue={event && event?.data?.eventTiming?.startTime}
                element="time"
                // placeholder={FormLabal.startTime.placeHolder}
                Register={register}
                Errors={errors}
                FieldName="startTime"
                Label="Start Time"
                ValidationArr={[{ Type: "required" }]}
              />
              <Input
                WrapperClass="col-md-12"
                // defValue={event && event?.data?.eventTiming?.startTime}
                element="time"
                // placeholder={FormLabal.startTime.placeHolder}
                Register={register}
                Errors={errors}
                FieldName="endTime"
                Label="End Time"
                ValidationArr={[{ Type: "required" }]}
              />
            </div>
          </form>
        ) : (
          <>
            <h6>You can't edit this event</h6>
          </>
        )}
      </ModalWrapper>
    </MainComponentWrapper>
  );
};

export default EditEventModal;
